import { Component, computed, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { Checkbox } from 'primeng/checkbox';
import { Fluid } from 'primeng/fluid';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddon } from 'primeng/inputgroupaddon';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { RealmConfig, RealmGoogleConfig } from '@/lib-backend';

@Component({
    selector: 'app-website-info-google',
    standalone: true,
    imports: [FormsModule, InputText, Checkbox, Fluid, InputGroup, InputGroupAddon, Button, Tooltip],
    templateUrl: './google-tab.html',
})
export class GoogleTab {
    readonly realm = input.required<RealmConfig>();
    readonly draft = model.required<RealmGoogleConfig>();

    protected readonly dirty = computed(() =>
        JSON.stringify(this.draft()) !== JSON.stringify(this.realm().Google)
    );

    protected setField<K extends keyof RealmGoogleConfig>(field: K, value: RealmGoogleConfig[K]): void {
        this.draft.update(d => ({ ...d, [field]: value }));
    }

    protected resetAll(): void {
        this.draft.set({ ...this.realm().Google });
    }
}
